import React from "react";
import styles from "./HotTopicCard.module.scss";

const HotTopicCard = ({ item }) => {
  return (
    <div
      className={styles.showsImg}
      style={{
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundImage: `url("${item.img}")`,
      }}
    >
      <div>{item.title}</div>
    </div>
  );
};

export default HotTopicCard;
